/* eslint-disable import/prefer-default-export */

import { errorForConfig } from '../errors';

export const statusForState = ({ config }) => {
  const error = errorForConfig(config);
  return {
    status: error ? 500 : 200,
    error,
  };
};
